export default class ParametersFormatter {
    init({selectorsData, dateFormat, ugrFeatureEnabled, tzgFeatureEnabled, reportAuthorizationInfo, reportParamsStringBuilderConstructor}) {
        this.reportParamsStringBuilder = new reportParamsStringBuilderConstructor({
                data: {
                    users: selectorsData.users,
                    userGroupsFeatureEnabled: ugrFeatureEnabled,
                    tzGroupsFeatureEnabled: tzgFeatureEnabled,
                    userGroups: selectorsData.userGroups,
                    timeZoneGroups: selectorsData.timeZoneGroups,
                    cpList: selectorsData.customersProjects,
                    leaveTypesMap: selectorsData.leaveTypesMap,
                    statuses: selectorsData.statuses,
                    manageableUserIds: selectorsData.manageableUserIds,
                    projectsWithMaIds: selectorsData.projectsWithMaIds,
                },
                dateFormat: dateFormat,
                reportAuthorizationInfo: reportAuthorizationInfo,
            })
        return this
    }

    formatUsersSelection(userSelection, assignedInfo) {
        return this.reportParamsStringBuilder.getUserSelectionParamString(userSelection, assignedInfo);
    }

    formatOvertimeUsersSelection(userSelection) {
        return this.reportParamsStringBuilder.getUserSelectionParamString(userSelection);
    }

    formatCustomersAndProjectsSelection(cpSelection) {
        return this.reportParamsStringBuilder.getCPSelectionParamString(cpSelection);
    }

    formatLeaveTypesSelection(leaveTypeSelection) {
        return this.reportParamsStringBuilder.getLeaveTypeSelectionParamString(leaveTypeSelection);
    }

    formatStatusesSelection(statuses) {
        return this.reportParamsStringBuilder.getStatusesSelectionParamString(statuses);
    }
}


// WEBPACK FOOTER //
// ./web/js/parametersFormatting/ParametersFormatter.js